import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const axiosClient = axios.create({
    // Gửi kèm cookie httpOnly "sid" cho MỌI request (xác thực qua phiên, không còn Bearer trong localStorage).
    // Cần cho cả môi trường dev khác origin (localhost:3000 -> API); prod same-origin cũng vô hại.
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
// Add a request interceptor
axiosClient.interceptors.request.use(function (config: AxiosRequestConfig) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
axiosClient.interceptors.response.use(function (response: AxiosResponse) {
    return response.data;
}, function (error) {
    return Promise.reject(error);
});

export { axiosClient };
